import { Space, Button, Typography, Divider } from "antd";
import {
  DownloadOutlined,
  ShareAltOutlined,
  DeleteOutlined,
  CloseOutlined,
} from "@ant-design/icons";

const { Text } = Typography;

interface BulkActionsProps {
  selectedCount: number;
  onDownload: () => void;
  onShare: () => void;
  onDelete: () => void;
  onClearSelection: () => void;
  canShare?: boolean;
  canDelete?: boolean;
}

export default function BulkActions({
  selectedCount,
  onDownload,
  onShare,
  onDelete,
  onClearSelection,
  canShare = true,
  canDelete = true,
}: BulkActionsProps) {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "12px 16px",
        background: "rgba(15, 110, 86, 0.04)",
        borderRadius: 8,
        marginBottom: 16,
        border: "1px solid rgba(15, 110, 86, 0.15)",
      }}
    >
      <Space>
        <Text strong>
          {selectedCount} {selectedCount === 1 ? "item" : "items"} selected
        </Text>
        <Button
          type="text"
          size="small"
          icon={<CloseOutlined />}
          onClick={onClearSelection}
        >
          Clear
        </Button>
      </Space>

      <Space split={<Divider type="vertical" />}>
        <Button
          type="text"
          icon={<DownloadOutlined />}
          onClick={onDownload}
        >
          Download
        </Button>
        {canShare && (
          <Button type="text" icon={<ShareAltOutlined />} onClick={onShare}>
            Share
          </Button>
        )}
        {canDelete && (
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={onDelete}
          >
            Delete
          </Button>
        )}
      </Space>
    </div>
  );
}
